/*
 * @Author: your name
 * @Date: 2020-11-27 14:09:04
 * @LastEditTime: 2021-11-22 10:50:03
 * @LastEditors: zhangcx33595
 * @Description: In User Settings Edit
 * @FilePath: \openplat-web\src\gtn\api\indexApi.js
 */
import fetch from "./httpFetch.js";
import Cookies from "js-cookie";
const modelName = "/openplat-service-server/v/system";
const infomation = "/openplat-service-server/v/infomation";

/**
 * @description: 查询首页配置动态
 * @param {*}
 * @return {*}
 */
export function getPortalSettings(data) {
  return fetch.get(modelName + "/getPortalSettings?entry_code=" + data);
}
/***轮播***/
export function newBroadcasts() {
  return fetch.post(modelName + "/newBroadcasts");
}

/***获取系统公告***/
export function getPlatformAnnouncement(data) {
  return fetch.post(infomation + "/getPlatformAnnouncement", data);
}

/***确认更新内容***/
export function postCurPlatformAnnouncement(data) {
  return fetch.post(infomation + "/readPlatformAnnouncement", data);
}
/***确认光子通知弹窗是否展示***/
export function confirmPhoMall(data) {
  return fetch.post(infomation + "/getPhoMall", data);
}
/***确认光子通知弹窗**/
export function readPhoMall(data) {
  return fetch.post(infomation + "/readPhoMall", data);
}
/**
 * @description: 查询首页用户服务信息
 * @param {*}
 * @return {*}
 */
export function getUserServiceStatisticsForHome() {
  return fetch.post(
    `/openplat-service-server/v/service/getUserServiceStatisticsForHome`
  );
}
// export function getUserServiceStatisticsForHome() {
//   return fetch.post(
//     `/openplat-user-server/v/getUserCloudResourceAccessRecords`
//   );
// }
/**
 * @description: 首页大数据展示接口
 * @param {*}
 * @return {*}
 */
export function getPortailApiCall() {
  return fetch.get("/openplat-user-server/v/getPortailApiCall");
}
/**
 * @description: 首页登陆消息统计
 * @param {*}
 * @return {*}
 */
// export function newBroadcasts() {
//   return fetch.post(modelName + "/newBroadcasts");
// }
/**
 * @description: 查询首页公告模块接口
 * @param {*} data
 * @return {*}
 */
export function queryInfomationPage(data) {
  return fetch.post(infomation + "/queryInfomationPage", data);
}
/**
 * @description: 根据分类查询服务列表
 * @param {*} data
 * @return {*}
 */
export function queryMarketDetailOutList(data) {
  return fetch.post(
    "/openplat-service-server/v/service/queryMarketDetailOutList",
    data
  );
}
// 首页待办工单数据
export function getWorkOrderTodo(data) {
  return fetch.get(
    "/openplat-service-server/v/getWorkOrderTodo",
    data
  );
}
/**
 * @description: 获取首页初始化产品列表
 * @param {*} data
 * @return {*}
 */
export function getPortalSettingsProductInfo(data) {
  return fetch.get(modelName + "/getPortalSettingsProductInfo", data);
}
/**
 * @description: 获取首页初始化产品列表
 * @param {*} data
 * @return {*}
 */
export function getPortalSettingsInfo() {
  return fetch.get(modelName + "/getPortalSettingsInfo?entry_code=");
}
/**
 * @description: 获取是否在内网展示
 * @param {*} data
 * @return {*}
 */
export function officeNetwork() {
  return fetch.get("/openplat-auth-server/v/office_network");
}
// 用户是否初次浏览网站
export function guideForgetPasswdApi(params) {
  return fetch.get("/openplat-auth-server/v/guideForgetPasswd", { params });
}
// 获取登录ticket
export function getTmpTicket() {
  return fetch.get("/openplat-auth-server/v/get_tmp_ticket");
}
/**
 * @description: 查询云公告
 * @param {*} data
 * @return {*}
 */
export function queryBlogListForHome() {
  let data = { page_size: 10 };
  return fetch.post(modelName + "/queryBlogListForHome", data);
}
/**
 * @description: 查询行情接口
 * @param {*} data
 * @return {*}
 */
export function queryMarketCalendar() {
  let data = {
    page_num: 1,
    page_size: 5,
    business: "",
    notice_type: "业务变更",
    market: "",
    start_date: ""
  };
  return fetch.post(
    "/openplat-service-server/v/market/queryMarketCalendar",
    data
  );
}
/**
 * @description: 查询常用服务
 * @param {*} data
 * @return {*}
 */
export function getUsualService() {
  let data = {
    page_size: 2,
    page_num: 1,
    service_name: "",
    environment_type: "",
    use_status: "",
    appkey: "",
    client_name: "",
    alternation_id: "",
    service_end_time_begin: "",
    service_end_time_end: ""
  };
  return fetch.post(
    "/openplat-service-server/v/myservice/listMyServicePortal",
    data
  );
}



// WEBPACK FOOTER //
// ./src/gtn/api/indexApi.js